import { Button } from "primereact/button";
import { Tag } from "primereact/tag";

import styles from "./imagem-card.module.scss";
import type { ImagemCardViewModel } from "./types-imagem-card";

export function ImagemCardView({
  testId,
  testIds,
  url,
  label,
  principal,
  fileName,
  imageRef,
  aoCarregar,
  info,
  baixar,
  downloadFalhou,
  downloadLabel,
  downloadAriaLabel,
  imageDownloadAriaLabel,
  principalLabel,
  downloadErrorMessage,
}: ImagemCardViewModel) {
  return (
    <article className={styles.card} aria-label={label} data-testid={testId}>
      <div className={principal ? `${styles.preview} ${styles.previewAvatar}` : styles.preview}>
        <button
          type="button"
          className={styles.previewButton}
          aria-label={imageDownloadAriaLabel}
          onClick={baixar}
          data-testid={testIds.imageDownload}
        >
          <img
            ref={imageRef}
            className={styles.image}
            src={url}
            alt={label}
            loading="eager"
            decoding="async"
            onLoad={aoCarregar}
            data-testid={testIds.image}
          />
        </button>
      </div>

      <div className={styles.body}>
        <div className={styles.titleRow}>
          <h3 className={styles.title}>{label}</h3>
          {principal ? (
            <Tag value={principalLabel} severity="secondary" className="p-tag-compact" />
          ) : null}
        </div>
        <p className={styles.fileName} data-testid={testIds.fileName}>
          {fileName}
        </p>
        <p className={styles.fileInfo} data-testid={testIds.fileInfo}>
          {info}
        </p>
        <Button
          type="button"
          className={styles.download}
          label={downloadLabel}
          severity="secondary"
          size="small"
          aria-label={downloadAriaLabel}
          onClick={baixar}
          data-testid={testIds.download}
        />
        {downloadFalhou ? (
          <p className={styles.downloadError} role="alert" data-testid={testIds.downloadError}>
            {downloadErrorMessage}
          </p>
        ) : null}
      </div>
    </article>
  );
}
